import React, { useMemo, useState } from 'react';
import { Select } from 'antd';
import { useCourses, UseCoursesParams } from '@hooks/courses';
import { debounce } from 'lodash';

export const SEARCH_DEBOUNCE = 300;

export const DEFAULT_PARAMS: UseCoursesParams = {
  page: 1,
  pageSize: 500,
  visibility: 'public',
};

type CourseSelectProps = {
  onChange: (courseId: number) => void;
  value?: number;
  style?: React.CSSProperties;
};

export const CourseSelect: React.FC<CourseSelectProps> = ({ onChange, value, style }) => {
  const [params, setParams] = useState<UseCoursesParams>(DEFAULT_PARAMS);
  const { data, isLoading } = useCourses(params);

  const options = useMemo(() => {
    return data.data.map((course: Course) => ({
      label: course.name,
      value: course.id,
    }));
  }, [data]);

  const handleSearch = (searchText: string) => {
    return debounce(() => {
      setParams({
        ...params,
        searchText,
      });
    }, SEARCH_DEBOUNCE);
  };

  return (
    <Select
      showSearch
      options={options}
      style={style}
      value={value}
      loading={isLoading}
      filterOption={(inputValue, option) =>
        (option?.label || '').toLowerCase().includes(inputValue.toLowerCase())
      }
      onSearch={handleSearch}
      onChange={onChange}
      placeholder="Select course"
      allowClear
    />
  );
};
